export class WarehousesQuery {
  static get KEYS () {
    return {
      NAME: 'name',
      TYPE: 'type',
      DEPARTMENT: 'department'
    };
  }
}
